import { Directive, TemplateRef } from '@angular/core';

/** Custom group-header template; replaces the structured title/subtitle/badge layout. */
@Directive({ selector: '[phxGroupHeader]' })
export class PhxGroupHeaderDirective {
  constructor(public templateRef: TemplateRef<void>) {}
}
